const HREFLANG_ENVS = [
  { uk: 'https://policymogul.com', us: 'https://us.policymogul.com' },
  { uk: 'https://staging.policymogul.com', us: 'https://us-staging.policymogul.com' },
];

const injectHreflangTags = () => {
  const appUrl = import.meta.env.VITE_APP_APPURL;
  const env = HREFLANG_ENVS.find(({ uk, us }) => appUrl === uk || appUrl === us);
  if (!env || document.head.querySelector('link[hreflang]')) return;

  [
    { hreflang: 'en-gb', href: `${env.uk}/` },
    { hreflang: 'en-us', href: `${env.us}/` },
    { hreflang: 'x-default', href: `${env.uk}/` },
  ].forEach(({ hreflang, href }) => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = hreflang;
    link.href = href;
    document.head.appendChild(link);
  });
};

export default injectHreflangTags;
